// extracted by mini-css-extract-plugin
export var infoItem = "_pu-2";
export var title = "_pu-0";
export var value = "_pu-1";